import React from "react";
import { StyledScorebugPost } from "../StyledScorebug";

export const ScorebugPost = ({
  homeScore,
  awayScore,
  homeShootoutScore,
  awayShootoutScore,
}) => {
  const hasShootout = !!homeShootoutScore || !!awayShootoutScore;
  const homeDisplay = hasShootout
    ? `${homeScore}(${homeShootoutScore})`
    : `${homeScore}`;

  const awayDisplay = hasShootout
    ? `${awayScore}(${awayShootoutScore})`
    : `${awayScore}`;

  return (
    <StyledScorebugPost className="mls-c-scorebug__post">
      <span className="mls-c-scorebug__score">{homeDisplay}</span>
      <span className="mls-c-scorebug__separator" />
      <span className="mls-c-scorebug__score">{awayDisplay}</span>
    </StyledScorebugPost>
  );
};
